import { Injectable } from '@angular/core';
import {UrlQueryService} from '../../../common/url-query/url-query.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RoutingRuleApiService {

  constructor(private http: HttpClient) {}

  private readonly routingRuleUrl: string = 'routing/routingRule';

  public addNewRule(rule): Promise<any> {
    return this.http.post(`${this.routingRuleUrl}`, rule).toPromise();
  }

  public getRules(params: any = {}): Promise<any> {
    if (params && params.filter && typeof params.filter === 'string') {
      params.filter = this.attachGeneralSearchFilter(params);
    }

    const generatedUrl = UrlQueryService.addQueryParameters(this.routingRuleUrl, params);

    return this.http.get(generatedUrl).toPromise();
  }

  public getRuleById(ruleId): Promise<any> {
    return this.http.get(`${this.routingRuleUrl}/${ruleId}`).toPromise();
  }

  public moveExistingRule(ruleId, rule): Promise<any> {
    return this.http.put(`${this.routingRuleUrl}/${ruleId}`, rule).toPromise();
  }

  public editExistingRule(rule): Promise<any> {
    return this.http.put(`${this.routingRuleUrl}/${rule.id}`, rule).toPromise();
  }

  public editExistingRules(rulesIds, ruleData): Promise<any> {
    return this.http.put(this.addRulesIDsToRequest(this.routingRuleUrl, rulesIds), ruleData).toPromise();
  }

  public deleteRules(rules): Promise<any> {
    return this.http.delete(this.addRulesIDsToRequest(this.routingRuleUrl, rules)).toPromise();
  }

  private addRulesIDsToRequest = (uri, idArray) => {
    return uri + '?' + this.addIdList(idArray);
  }

  private addIdList(idArray): string {
    let result = 'filter=(id=';

    idArray = Array.isArray(idArray) ? idArray : [idArray];

    idArray.forEach((id, index) => {
      if (index > 0) { result += ';'; }

      result += id;
    });

    return result + ')';
  }

  private attachGeneralSearchFilter(parameters): any {
    return {
      searchString: {
        operator: ':',
        value: parameters.filter
      }
    };
  }
}
